/* eslint-disable sonarjs/media-has-caption */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable no-underscore-dangle */
/* eslint-disable sonarjs/mouse-events-a11y */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useCallback, useMemo, useState } from 'react';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { APIProvider } from '@vis.gl/react-google-maps';
import getCategoryIcon from '../../media/categoriesMap';
import { dateFormat } from '../../utils/time';
import ReportsMap from '../map/ReportsMap';
import closeIcon from '../../media/icons/close.svg';
import GalleryView from './GalleryView';
import getTypeComponent from '../types/index';
import { getReport } from '../../api/reports';
import ReportsList from './ReportsList';
import ProjectsList from './ProjectsList';
import CreateBroadcastModal from './CreateBroadcastModal';

const isImage = (link) => link.toLowerCase().match(/\.(jpeg|jpg|gif|png)/);
const isVideo = (link) => link.toLowerCase().match(/\.(mp4|ogg|mov)/);

const BetaReportsScreen = ({ reports, projects, locations, heatmap, mapFilters }) => {
  const { t } = useTranslation();

  const [filteredReports, setFilteredReports] = useState([]);
  const [projectBroadcast, setProjectBroadcast] = useState();

  const [filterValue, setFilterValue] = useState('');
  const [filteredCategories, setFilteredCategories] = useState('');

  const [selectedImg, setSelectedImg] = useState();

  const [loaded, setLoaded] = useState(false);
  const [mapRef, setMapRef] = useState(null);
  const [selectedView, setSelectedView] = useState('reports');
  const [selectedReport, setSelectedReport] = useState();
  const [selectedUserId, setSelectedUserId] = useState();

  const onSetMap = useCallback((map) => setMapRef(map), []);

  const onSelectUser = useCallback((val) => {
    setSelectedReport(undefined);
    setSelectedUserId(val);
  }, []);

  const onSelectReport = useCallback((id) => {
    setSelectedUserId(undefined);
    const fetchData = async () => {
      try {
        const rep = await getReport(id);
        setSelectedReport(rep);
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchData();
  }, []);

  const handleBroadcastModalClose = useCallback(() => {
    setProjectBroadcast(undefined);
  }, []);

  const closeModal = () => {
    document.body.classList.remove('modal-open');
    setSelectedImg(null);
  };

  const filteredLocationsByProject = useMemo(() => {
    return locations.filter(
      (l) =>
        (filterValue.trim().length === 0 && filteredCategories.length === 0) ||
        //
        (filterValue.trim().length > 0 &&
          l.user.name.toLowerCase().includes(filterValue.toLowerCase())) ||
        l.user.project.name.toLowerCase().includes(filterValue.toLowerCase()) ||
        //
        (filterValue.trim().length === 0 && filteredCategories.includes(String(l.user.project?.id)))
    );
  }, [filterValue, filteredCategories, locations]);

  const filteredLocations = useMemo(() => {
    if (filterValue.trim().length === 0) return filteredLocationsByProject;
    return locations.filter((l) => l.user.name.toLowerCase().includes(filterValue.toLowerCase()));
  }, [filteredLocationsByProject, filterValue]);

  return (
    <div>
      <div className="reports-sidebar drop-shadow-md h-full">
        <div className="text-sm font-medium text-center text-gray-500">
          <ul className="flex flex-wrap -mb-px">
            <li className="flex-grow">
              <button
                type="button"
                onClick={() => setSelectedView('reports')}
                className={cx('w-full inline-block p-4 border-b-4 text-lg', {
                  'border-[#F4F5F7] hover:border-gray-300 hover:text-gray-500 text-gray-400':
                    selectedView !== 'reports',
                  'border-[#37C2D7] text-black': selectedView === 'reports',
                })}
              >
                {t('reports.title')}
              </button>
            </li>
            <li className="flex-grow">
              <button
                type="button"
                onClick={() => setSelectedView('projects')}
                className={cx('w-full inline-block p-4 border-b-4 text-lg', {
                  'border-[#F4F5F7] hover:border-gray-300 hover:text-gray-500 text-gray-400':
                    selectedView !== 'projects',
                  'border-[#37C2D7] text-black': selectedView === 'projects',
                })}
                aria-current="page"
              >
                {t('projects.title')}
              </button>
            </li>
          </ul>
        </div>
        {selectedView === 'reports' && (
          <ReportsList
            reports={reports}
            setSelectedReportPopup={setSelectedReport}
            mapRef={mapRef}
            setFilteredReports={setFilteredReports}
          />
        )}
        {selectedView === 'projects' && (
          <ProjectsList
            projects={projects.map((p) => ({
              ...p,
              members: filteredLocationsByProject.filter((l) => l.user.project?.id === p.id),
            }))}
            mapRef={mapRef}
            users={filteredLocationsByProject}
            setSelectedUserId={onSelectUser}
            // setFilteredProjects={setFilteredProjects}
            setProjectBroadcast={setProjectBroadcast}
            filterValue={filterValue}
            filteredCategories={filteredCategories}
            setFilterValue={setFilterValue}
            setFilteredCategories={setFilteredCategories}
          />
        )}
      </div>
      <APIProvider apiKey="AIzaSyA1aXX9T5Ylii6PX1wjV_lTAVqT3ljP6Dg" onLoad={() => setLoaded(true)}>
        {loaded && (
          <ReportsMap
            onSetMap={onSetMap}
            reports={filteredReports}
            locations={filteredLocations}
            projects={projects}
            onSelectReport={onSelectReport}
            selectedReportId={selectedReport?._id}
            setSelectedUserId={onSelectUser}
            selectedUserId={selectedUserId}
            heatmap={heatmap}
            mapFilters={mapFilters}
          />
        )}
      </APIProvider>
      {selectedReport && (
        <div className="absolute top-[25px] left-[25px] w-[450px] bg-white rounded-lg drop-shadow-md z-40">
          <button
            type="button"
            className="cursor-pointer absolute top-3 right-3"
            onClick={() => setSelectedReport(undefined)}
          >
            <img src={closeIcon} alt="" />
          </button>
          <div className="p-4 overflow-y-scroll h-[700px]">
            <h2 className="inline-block w-full mb-4 text-[19px]">{t('reports.report_details')}</h2>
            <br />
            <div className="inline-flex items-center pt-5">
              <img
                className="w-[60px] h-[60px]"
                src={getCategoryIcon(selectedReport.type)}
                alt=""
              />
              <span className="pl-2 text-[20px] font-medium">{selectedReport.title}</span>
            </div>
            <br />
            <div className="text-[14px] pt-6">
              <span className="opacity-50 uppercase">{t('reports.table_reporter')}</span>
              <br />
              {selectedReport.reporter?.name}
              {selectedReport.reporter?.email && <span>, {selectedReport.reporter?.email}</span>}
              <div className="border-b mt-4 mb-4 border-[#F4F5F7]" />
              <span className="opacity-50">{t('reports.date_when_time')}</span>
              <br />
              {dateFormat(selectedReport.timestamp, 'MMM D, YYYY')}
              <span className="sub-info">, {dateFormat(selectedReport.timestamp, 'HH:mm')}</span>
              <div className="border-b mt-4 mb-4 border-[#F4F5F7]" />
              <span className="opacity-50 uppercase">{t('reports.table_location')}</span>
              <br />
              {selectedReport.location?.reverse && (
                <>
                  <span>
                    {selectedReport.location.reverse.city},{' '}
                    {selectedReport.location.reverse.country}
                  </span>
                  <br />
                </>
              )}
              {selectedReport.location ? (
                <span>
                  {selectedReport.location.latitude},{selectedReport.location.longitude}
                </span>
              ) : (
                <span>{t('reports.no_coordinates')}</span>
              )}
              <div className="further-details-map">
                <div>{getTypeComponent(selectedReport)}</div>
                <div className="border-b mt-4 mb-4 border-[#F4F5F7]" />
                <div className="images">
                  <h2 className="inline-block w-full">{t('reports.images_videos')}</h2>
                  <GalleryView media={selectedReport.uploaded} setSelected={setSelectedImg} />
                </div>
                <div className="border-b mt-4 mb-4 border-[#F4F5F7]" />
                <div className="comments">
                  <h2 className="inline-block w-full">{t('reports.comments')}</h2>
                  <br />
                  {selectedReport.comments ? (
                    <div>
                      <p
                        style={{ overflowWrap: 'break-word' }}
                        className="bg-[#37C2D7]/10 p-2 mt-2"
                      >
                        {selectedReport.comments}
                      </p>
                    </div>
                  ) : (
                    <div>
                      <p>{t('reports.no_comments')}</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {projectBroadcast && (
        <CreateBroadcastModal
          projectBroadcast={projectBroadcast}
          handleBroadcastModalClose={handleBroadcastModalClose}
          setProjectBroadcast={setProjectBroadcast}
        />
      )}

      {selectedImg && (
        <teleport to="body">
          <div className="fixed z-50 inset-0 overflow-y-auto bg-black/50">
            <div className="flex flex-row items-center align-middle justify-center min-h-screen m-auto">
              <div
                className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl w-2/3 h-[80dvh]"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-headline"
              >
                <button
                  type="button"
                  className="cursor-pointer absolute top-3 right-3"
                  onClick={closeModal}
                >
                  <img src={closeIcon} alt="" />
                </button>

                {isImage(selectedImg) && (
                  <img
                    className="w-full h-full object-contain p-12 m-auto overflow-hidden block align-middle"
                    src={selectedImg}
                    alt=""
                  />
                )}
                {isVideo(selectedImg) && (
                  <div className="w-full h-full flex items-center justify-center p-12 ">
                    <video
                      width="100%"
                      controls
                      className="object-contain overflow-hidden block align-middle"
                    >
                      <source src={selectedImg} />
                    </video>
                  </div>
                )}
              </div>
            </div>
          </div>
        </teleport>
      )}
    </div>
  );
};

export default BetaReportsScreen;
